import { all } from 'redux-saga/effects';
import customerFeedbackSaga from './feedback';
import customerListSaga from './list';
import loyaltySaga from './loyalty';
import loyaltySubscriptionSaga from './loyaltySubscription';

export default function* customersSaga() {
  yield all([
    customerFeedbackSaga(),
    customerListSaga(),
    loyaltySaga(),
    loyaltySubscriptionSaga(),
  ]);
}
